import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import SelectDropdown from '../select-dropdown'
import Item from './item'
import css from './select.css'

const { arrayOf, bool, func, number, string } = PropTypes

export default class SelectList extends PureComponent {
    static propTypes = {
        options: arrayOf(string).isRequired,
        label: string,
        placeholder: string,
        title: string,
        width: number,
        allowMultiple: bool,
        // The default list of active items
        active: arrayOf(string),
        // Items to be rendered with a 'new' pill
        new: arrayOf(string),
        isDark: bool,
        onChange: func.isRequired,
        extendUp: bool,
        nipX: string,
    }

    static defaultProps = {
        active: [],
        new: [],
        placeholder: 'Options',
        allowMultiple: true,
        extendUp: false,
    }

    state = {
        activeItems: this.props.active,
        newItems: this.props.new,
    }

    onItemClick(item) {
        const { allowMultiple, onChange } = this.props
        const { activeItems } = this.state
        const index = activeItems.indexOf(item)
        let items = [...activeItems]

        if (allowMultiple) {
            index > -1 ? items.splice(index, 1) : items.push(item)
        } else {
            items = index > -1 ? [] : [item]
        }

        this.setState({ activeItems: items })
        onChange(allowMultiple ? items : items[0] || null)
    }

    render() {
        const { children, placeholder, options, label, title, width, theme, extendUp, className, nipX } = this.props
        const { activeItems, newItems } = this.state
        return (
            <SelectDropdown
                className={className}
                extendUp={extendUp}
                label={label || activeItems.join(', ')}
                nipX={nipX}
                placeholder={placeholder}
                theme={theme}
                width={width}
            >
                <div>
                    {title && <div className={css.listName}>{title}</div>}
                    {options.map((option, i) => (
                        <Item
                            isActive={activeItems.indexOf(option) > -1}
                            isDark={theme === 'dark' || theme === 'transparentDark'}
                            key={i}
                            label={option}
                            newPill={newItems.indexOf(option) > -1}
                            onClick={() => this.onItemClick(option)}
                        />
                    ))}
                    {children}
                </div>
            </SelectDropdown>
        )
    }
}
